import { createStore, createHook, createActionsHook, createStateHook } from 'react-sweet-state';
import type {
	BoundActions,
	HookActionsFunction,
	HookFunction,
	HookStateFunction,
	StoreActionApi,
} from 'react-sweet-state';

import type { ExtractPresetAPI } from '@atlaskit/editor-common/preset/builder';
import type { fullPagePreset } from '@atlassian/confluence-presets/full-page';

export type FullPageEditorPresetAPI = ExtractPresetAPI<ReturnType<typeof fullPagePreset>>;

export type FullPageEditorStoreState = {
	fullPageEditorPresetAPI?: FullPageEditorPresetAPI;
};

export const initialState: FullPageEditorStoreState = {
	fullPageEditorPresetAPI: undefined,
};

export const actions = {
	setEditorApi:
		(fullPageEditorPresetAPI?: FullPageEditorPresetAPI) =>
		({ setState }: StoreActionApi<FullPageEditorStoreState>): void => {
			setState({
				fullPageEditorPresetAPI,
			});
		},
	resetEditorApi:
		() =>
		({ setState }: StoreActionApi<FullPageEditorStoreState>): void => {
			setState(initialState);
		},
};

const FullPageEditorApiStore = createStore({
	initialState,
	actions,
	name: 'FullPageEditorApiStore',
});

export const useFullPageEditorApi: HookFunction<
	FullPageEditorStoreState,
	BoundActions<
		FullPageEditorStoreState,
		{
			setEditorApi: (
				fullPageEditorPresetAPI?: FullPageEditorPresetAPI,
			) => ({ setState }: StoreActionApi<FullPageEditorStoreState>) => void;
			resetEditorApi: () => ({ setState }: StoreActionApi<FullPageEditorStoreState>) => void;
		}
	>,
	void
> = createHook(FullPageEditorApiStore);
export const useFullPageEditorApiActions: HookActionsFunction<
	BoundActions<
		FullPageEditorStoreState,
		{
			setEditorApi: (
				fullPageEditorPresetAPI?: FullPageEditorPresetAPI,
			) => ({ setState }: StoreActionApi<FullPageEditorStoreState>) => void;
			resetEditorApi: () => ({ setState }: StoreActionApi<FullPageEditorStoreState>) => void;
		}
	>
> = createActionsHook(FullPageEditorApiStore);
export const useFullPageEditorApiState: HookStateFunction<FullPageEditorStoreState, void> =
	createStateHook(FullPageEditorApiStore);
